import {Box, Text} from '@primer/styled-react'
import {Tooltip} from '@primer/react/deprecated'
import {Octicon} from '@primer/styled-react/deprecated'
import {AlertIcon, CheckIcon, XIcon} from '@primer/octicons-react'
import {GitHubAvatar} from '@github-ui/github-avatar'

import styles from './ListItem.module.css'

type ListItemProps = {
  state: string
  avatarLabel?: string
  avatarUrl?: string
  hovercardUrl?: string
  title: string
  description?: string
  warning?: string
  titleClass?: string
  paddingY?: number
  paddingLeft?: number
}
export function ListItem({
  state,
  avatarLabel,
  avatarUrl,
  hovercardUrl,
  title,
  description,
  warning,
  titleClass,
  paddingY,
  paddingLeft,
}: ListItemProps) {
  return (
    <Box
      as="li"
      sx={{
        paddingY: paddingY ?? 2,
        paddingLeft: paddingLeft ?? 2,
      }}
      className={styles.ListItemContainer}
    >
      <Octicon
        icon={state === 'success' ? CheckIcon : XIcon}
        sx={{
          color: state === 'success' ? 'success.fg' : 'danger.fg',
        }}
      />
      {avatarUrl && <GitHubAvatar aria-label={avatarLabel} src={avatarUrl} data-hovercard-url={hovercardUrl} />}
      <Text className={titleClass} sx={{fontWeight: titleClass ? undefined : 'bold'}}>
        {title}
      </Text>
      {description ? <span className={styles.ListItemText}>{description}</span> : null}
      {warning && (
        <Tooltip aria-label={warning} wrap>
          <AlertIcon size={16} />
        </Tooltip>
      )}
    </Box>
  )
}

try{ ListItem.displayName ||= 'ListItem' } catch {}